export default {"src":"/_next/static/media/call-blue.412d2252.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};